let maxSize: number;

export const getMaxWebGlTextureSize = () => {
  if (maxSize) return maxSize;
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl');
  if (!gl) return 0;
  maxSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
  return maxSize;
};
